var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-716f10b9-a1b2-458c-8d4a-42403d9b808b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-20c9530d-0878-46be-b2bd-602e5b8727bc {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-20c9530d-0878-46be-b2bd-602e5b8727bc",
    d: "M21.99,21.54h-11.98c-.55,0-1-.45-1-1v-9.07c0-.55.45-1,1-1h7.21c.38,0,.72.21.89.54l.3.59h3.58c.55,0,1,.45,1,1v7.93c0,.55-.45,1-1,1ZM11.01,19.54h9.98v-5.93h-3.19c-.38,0-.72-.21-.89-.54l-.3-.59h-5.6v7.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.0a3091e841659c2ab2cd95585c709986.svg";
export { ForwardRef as ReactComponent };